import type { RoleDefinition } from '@/api/types';

// 사용자 관리 화면이 다루는 역할 선택지 — admin(승인자, 고정) + 서버 역할 정의(leader/member/커스텀).
// guest 는 '역할 없음'이라 선택지가 아니다.

export interface RoleOption {
  key: string;
  label: string;
  description: string | null;
  kind: 'admin' | 'system' | 'custom';
}

export const ADMIN_OPTION: RoleOption = {
  key: 'admin',
  label: 'Admin',
  description: '모든 메뉴 편집 + 승인·사용자·역할 관리',
  kind: 'admin',
};

export function buildRoleOptions(roles: RoleDefinition[]): RoleOption[] {
  return [
    ADMIN_OPTION,
    ...roles.map((r) => ({
      key: r.key,
      label: r.label,
      description: r.description,
      kind: r.is_system ? ('system' as const) : ('custom' as const),
    })),
  ];
}

// 칩 색 토큰 — RoleSelect.module.css 의 tone* 클래스와 짝을 이룬다.
export type RoleTone = 'toneAdmin' | 'toneLeader' | 'toneMember' | 'toneCustom' | 'toneGuest';

export function roleTone(option: Pick<RoleOption, 'key' | 'kind'>): RoleTone {
  if (option.kind === 'admin') return 'toneAdmin';
  if (option.key === 'leader') return 'toneLeader';
  if (option.key === 'member') return 'toneMember';
  return 'toneCustom';
}
